<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Safety Observations</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close the Safety Observations filter."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="category">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 210px;">
        <mat-label>Category</mat-label>
        <mat-select
          placeholder="Category"
          [(ngModel)]="filters.so_category"
          name="category"
          matTooltip="Filter safety observations by category.">
          <mat-option value="">All Categories</mat-option>
          <mat-option *ngFor="let so_category of utils.getSafetyObservationCategories()" [value]="so_category">
            {{so_category}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 210px;">
        <mat-label>Type</mat-label>
        <mat-select
          placeholder="Type"
          [(ngModel)]="filters.so_type"
          name="type"
          matTooltip="Filter safety observations by type.">
          <mat-option value="">All Types</mat-option>
          <mat-option *ngFor="let so_type of utils.getSafetyObservationTypes()" [value]="so_type">
            {{so_type}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="priority">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 150px;">
        <mat-label>Priority</mat-label>
        <mat-select
          placeholder="Priority"
          [(ngModel)]="filters.so_priority"
          name="priority"
          matTooltip="Filter safety observations by priority.">
          <mat-option value="">All Priorities</mat-option>
          <mat-option *ngFor="let so_priority of utils.getSafetyObservationPriorities()" [value]="so_priority">
            {{so_priority}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 180px;">
        <mat-label>Status</mat-label>
        <mat-select
          placeholder="Status"
          [(ngModel)]="filters.so_status"
          name="status"
          matTooltip="Filter safety observations by status.">
          <mat-option value="">All Statuses</mat-option>
          <mat-option *ngFor="let so_status of utils.getSafetyObservationStatuses()" [value]="so_status">
            {{so_status}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="rating">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 120px;">
        <mat-label>Rating</mat-label>
        <mat-select
          placeholder="Rating"
          [(ngModel)]="filters.so_rating"
          name="rating"
          matTooltip="Filter safety observations by rating.">
          <mat-option value="">Ratings</mat-option>
          <mat-option [value]="1">Very Bad</mat-option>
          <mat-option [value]="2">Bad</mat-option>
          <mat-option [value]="3">Neutral</mat-option>
          <mat-option [value]="4">Good</mat-option>
          <mat-option [value]="5">Very Good</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectSites()"
        [matBadge]="'' + (filters.site_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>location_on</mat-icon> {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectContractors()"
        [matBadge]="'' + (filters.contractor_ids.length || 'All')"
        class="mx-3 mt-2">
        <fa-icon [icon]="faHardHat"></fa-icon> {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectUsers()"
        [matBadge]="'' + (filters.user_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>people</mat-icon> Assigned Users
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectAssets()"
        [matBadge]="'' + (filters.asset_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>forklift</mat-icon> Assets
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="buttons">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectReportedBy()"
        [matBadge]="'' + (filters.reported_by_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>people</mat-icon> Reported By
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_range">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker dateRangeTitle="Date Range" dateRangePlaceholder="Select Date Range" dateRangeTooltip="Filter Safety Observations by date range." [dateRangeInput]="filters.date_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">
  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filters
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon>clear_all</mat-icon> Clear Filters
      </button>
    </div>

    <div class="p-2" *ngIf="filters.date_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>
</mat-dialog-actions>
